module.exports = __webpack_public_path__ + "static/logo-a1f0dd26b5e986c8b9d362aec4fad576.png";